













import { Component, Vue } from 'vue-property-decorator';
import ElementPlayerModal from '@/views/presentation/components/ElementPlayerModal.vue';
import { ElementListItem, PresentationTableItem } from '@/models/Presentation';
import PresentationService from '@/service/PresentationService';

@Component({
  components: { ElementPlayerModal }
})
export default class PreviewModal extends Vue {
  currentPresentation: PresentationTableItem | null = null;
  items: ElementListItem[] = [];
  selectedElementIdx = -1;

  showPreview(item: PresentationTableItem) {
    this.currentPresentation = item;
    this.loadElements().then(() => {
      this.selectedElementIdx = 0;
      this.$nextTick(() => {
        this.$bvModal.show('element-player-modal');
      });
    });
  }

  async loadElements() {
    if (this.currentPresentation) {
      this.items = (await PresentationService.getElements(this.currentPresentation.id))
        .map(PresentationService.elementToListItem);
    }
  }


  clear() {
    this.currentPresentation = null;
    this.items = [];
    this.selectedElementIdx = -1;
  }

  setSelectedElement(item: ElementListItem): void {
    this.selectedElementIdx = this.items.findIndex(i => i.id === item.id);
  }
}
